/**
 * Отрисовка блоков вопрос-ответа (h2/h3/h4/p/li) — один код на два места.
 *
 * До 30.08.2026 эта функция жила внутри FaqSection и была ей одной и нужна.
 * Когда длинные разборы переехали с главной на страницы практик, тот же формат
 * понадобился и там: копия разошлась бы с оригиналом на первой же правке.
 *
 * `shift` опускает уровень заголовков на единицу. На главной вопрос — это
 * кнопка аккордеона, и h2 внутри ответа уместен; на странице практики сам
 * вопрос становится h2, и внутренние заголовки обязаны уйти на уровень ниже,
 * иначе на странице получается десяток h2 без иерархии.
 */
import type { QaBlock } from '@/data/homeQa';

export function renderQaBlocks(blocks: QaBlock[], shift = false) {
  const out: React.ReactNode[] = [];
  let list: string[] = [];

  const flushList = (key: string) => {
    if (!list.length) return;
    out.push(
      <ul key={key} className="list-disc pl-5 space-y-2 my-4">
        {list.map((text, i) => (
          <li key={i} className="font-body text-navy/70 text-sm lg:text-base leading-relaxed">
            {text}
          </li>
        ))}
      </ul>,
    );
    list = [];
  };

  blocks.forEach((block, i) => {
    if (block.tag === 'li') {
      list.push(block.text);
      return;
    }
    flushList(`ul-${i}`);
    const tag = shift
      ? ({ h2: 'h3', h3: 'h4', h4: 'h4', p: 'p' } as const)[block.tag] ?? 'p'
      : block.tag;

    if (tag === 'h2') {
      out.push(
        <h2 key={i} className="font-display text-navy text-xl lg:text-2xl font-bold leading-snug mt-8 mb-3 first:mt-0">
          {block.text}
        </h2>,
      );
    } else if (tag === 'h3') {
      out.push(
        <h3 key={i} className="font-display text-navy text-lg lg:text-xl font-semibold leading-snug mt-6 mb-2">
          {block.text}
        </h3>,
      );
    } else if (tag === 'h4') {
      out.push(
        <h4 key={i} className="font-display text-navy/90 text-base lg:text-lg font-semibold leading-snug mt-5 mb-2">
          {block.text}
        </h4>,
      );
    } else {
      out.push(
        <p key={i} className="font-body text-navy/70 text-sm lg:text-base leading-relaxed mb-4">
          {block.text}
        </p>,
      );
    }
  });
  flushList('ul-last');
  return out;
}
